import { get, flow, mapValues, groupBy, compact } from 'lodash/fp';

export default function getSelections(matchUps, selections) {
  const playerSelections = compact(
    matchUps.map((players, i) => players.find(p => p.id === selections[i]))
  );
  const grouped = flow(
    groupBy('positions[0].key'),
    mapValues(arr => arr.map(a => get('id', a)))
  )(playerSelections);
  return {
    players: grouped,
    teams: [],
    bonus_selections: []
  };
}

export function isPlayerWinning(player, opponent, winningAlgorithm) {
  switch (winningAlgorithm) {
    case 'lower_score':
      return player.score < opponent.score;
    default:
      return player.score > opponent.score;
  }
}

export function isPlayerLosing(player, opponent, winningAlgorithm) {
  switch (winningAlgorithm) {
    case 'lower_score':
      return player.score > opponent.score;
    default:
      return player.score < opponent.score;
  }
}
